import { apiBase } from '@/api/instance';
import Qs from 'qs';

export const SearchCategory = (params) => {
  return apiBase({
    url: `/cats/categories`,
    method: 'get',
    params: params,
    paramsSerializer: (params) => {
      return Qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
};

export const UploadImage = (formData) => {
  return apiBase({
    url: '/images/upload',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const StoreCategory = (params) => {
  return apiBase({
    url: '/cats/categories',
    method: 'post',
    data: params
  });
};

export const ShowCategory = ({ id }) => {
  return apiBase({
    url: `/cats/categories/${id}`,
    method: 'get'
  });
};

export const UpdateCategory = (params) => {
  return apiBase({
    url: `/cats/categories/${params.id}`,
    method: 'put',
    data: params
  });
};

export const DestroyCategory = ({ id }) => {
  return apiBase({
    url: `/cats/categories/${id}`,
    method: 'delete'
  });
};
